import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";
import { SUBJECT_DIALOG_MESSAGES, SubjectDialogMessages } from "./subject-dialog.messages";
import { SUBJECT_REQUEST_MESSAGES, SubjectRequestMessages } from "./subject-request.messages";
import { SUBJECT_TABLE_MESSAGES, SubjectTableMessages } from "./subject-table.messages";

export type SubjectFormMessages = SidebarMessages &
  ActionButtonMessages &
  PopoverMessages &
  SubjectRequestMessages &
  TableColumnsMessages &
  SubjectTableMessages &
  SubjectDialogMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    createPageTitle: string;
    updatePageTitle: string;
    viewPageTitle: string;
    subjectTableTitle: string;
    addSubjectButton: string;
    subjectCardTitle: string;
    errorRequiredSubject: string;
    subjectLabel: string;
    subjectPlaceholder: string;
  };

export const SUBJECT_FORM_MESSAGES: SubjectFormMessages = {
  pageTitle: "Assuntos",
  createPageTitle: "Criar Assunto",
  updatePageTitle: "Editar Assunto",
  viewPageTitle: "Visualizar Assunto",
  subjectTableTitle: "Listagem de Assuntos",
  breadCrumbTitle: "Assuntos",
  addSubjectButton: "Novo Assunto +",
  subjectCardTitle: "Informações do Assunto",
  errorRequiredSubject: "Por favor, insira o nome do assunto",
  subjectLabel: "Assunto",
  subjectPlaceholder: "Ex: Troca de item",

  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...POPOVER_MESSAGES,
  ...SUBJECT_REQUEST_MESSAGES,
  ...TABLE_COLUMNS_MESSAGES,
  ...SUBJECT_TABLE_MESSAGES,
  ...SUBJECT_DIALOG_MESSAGES,
};

export default SUBJECT_FORM_MESSAGES;
